import React, { useEffect, useState } from "react";
import axios from "axios";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import FooterCorp from "../modulos/footerCorp";
import { useLocation } from "react-router-dom";

import CadeteFormEdit from "./CadeteFormEdit";
import ModalCadete from "./Modal";
import ModalVeoInfo from "./Modal";
import ModalCreaSancion from "./Modal";
import ModalInfoSancion from "./Modal";
import ModalCondono from "./Modal";
import ModalInfoAviso from "./Modal";
import ModalInfoPaseSalida from "./Modal";
import ModalEditaJustifica from "./Modal";

import CreaSancion from "./CreaSancion";
import CadeteInfoCard from "./CadeteInfoCard";
import Sancion from "./Sancion";
import InfoAviso from "./InfoAviso";
import PaseDeSalidaInfo from "./PaseDeSalidaIngo";
import LegajoVirtual from "./LegajoVirtual";
import JustificarInasistencia from "./JustificarInasistencia";
import Condona from "./Condona";

import comprueboPermisos from "../tools/comprueboPermisos";
import devolvemeLaEdad from "../tools/devolvemeLaEdad";

import "./estiloCard.css";
import "./CadeteEditSave.css";

const CadetesEdit = () => {
const Usuario = ObtieneDatosCookies();
const location = useLocation();

const [visible, setVisible] = useState(false);
const [errorConsulta, setErrorConsulta] = useState(false);
const [cadete, setCadete] = useState(null);

const [modalAbierto, setModaAbierto] = useState(false);
const [verSancionar, setVerSancionar] = useState(false);
const [datosCadeteSancion, setDatosCadeteSancion] = useState(null);

const [modalVeoInfo, setModalVeoInfo] = useState(false);
const [modalInfoSancion, setModalInfoSancion] = useState(false);
const [sancionModalInfo, setSancionModalInfo] = useState(null);

const [modalInfoAviso, setModalInfoAviso] = useState(false);
const [avisoModalInfo, setAvisoModalInfo] = useState(null);

const [modalPaseSalida, setModalPaseSalida] = useState(false);
const [paseDeSalida, setPaseDeSalida] = useState(null);

const [veoModalJustifica, setVeoModalJustifica] = useState(false);
const [inasistenciaSeleccionada, setInasistenciaSeleccionada] = useState(null);

const [veoModalCondono, setVeoModalCondono] = useState(false);
const [veoLegajoVirtual, setVeoLegajoVirtual] = useState(false);

// ============================================================
// QUERY
// ============================================================

const consulta = new URLSearchParams(location.search);
const dniConsulta = consulta.get("dni");

// ============================================================
// TOKEN
// ============================================================

const token = btoa(
`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
);

// ============================================================
// OBTENER CADETE
// ============================================================

const obtieneCadete = async () => {
if (!dniConsulta) {
setErrorConsulta(true);
setVisible(true);
return;
}

const client = axios.create({
baseURL:
`${process.env.REACT_APP_BASEURL}NCadetes/devuelveCadeteParaEdit/${dniConsulta}`,
headers: {
Authorization: `Basic ${token}`
}
});

try {
setErrorConsulta(false);

const datos = await client.post("/");

if (datos?.data) {
setCadete(datos.data);

setDatosCadeteSancion({
cadeteDni: datos.data.cadeteDni,
Promocions: datos.data.Promocions
? datos.data.Promocions[0]
: [],
cadeteSede: datos.data.cadeteSede
});

setVisible(true);
} else {
setCadete(null);
setErrorConsulta(true);
setVisible(true);
}
} catch (error) {
console.error("Error obteniendo cadete:", error);
setCadete(null);
setErrorConsulta(true);
setVisible(true);
}
};

useEffect(() => {
obtieneCadete();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [dniConsulta]);

// ============================================================
// FOTO
// ============================================================

const muestroFoto = (valor) => {
if (!valor) return;

window.open(
`https://wwwa.isepsantafe.net.ar/imagenes/${valor}`,
"_blank",
"noopener,noreferrer"
);
};

// ============================================================
// EDICION CADETE
// ============================================================

const manejoCierre = async (dato) => {
if (dato) setCadete(dato);
setModaAbierto(false);
};

// ============================================================
// CARPETA MEDICA
// ============================================================

const manejoModalInfo = () => setModalVeoInfo(true);

// ============================================================
// CANTIDAD AMONESTACIONES
// ============================================================

const devuelveCantidadAmonestaciones = (info) => {
try {
if (!info?.Sanciones?.length) return 0;

return info.Sanciones.reduce((total, sancion) => {
let cantidad = 0;

if (sancion.estado === "Finalizada") {
cantidad = parseFloat(sancion.cantidadConfirma);
} else if (sancion.estado === "Finalizada Reclamada") {
cantidad = parseFloat(sancion.cantidadResuelveRecurso);
}

return total + (isNaN(cantidad) ? 0 : cantidad);
}, 0);

} catch {
return 0;
}
};

// ============================================================
// INASISTENCIA ACTIVA
// ============================================================

const esInasistenciaActiva = (ausencia) => {
if (!ausencia) return false;

const estado = String(ausencia.estado ?? "")
.trim()
.toLowerCase();

// Compatibilidad con registros antiguos sin estado
if (!estado) return true;

const estadosInactivos = [
"0",
"false",
"inactivo",
"inactiva",
"desactivada",
"condonada",
"anulada",
"anulado"
];

return !estadosInactivos.includes(estado);
};

// ============================================================
// TIPO DE CONDONACION
// ============================================================

// SISTEMA NUEVO:
// observacion contiene:
//
// "Inasistencias condonadas: 09/03/2026 - ..."
//
// Esas faltas ya fueron desactivadas.
//
// SISTEMA VIEJO:
// no tiene esa estructura.
// La cantidad sigue funcionando como crédito.

const esCondonacionNueva = (condona) => {
if (!condona) return false;

const observacion = String(
condona.observacion || ""
);

return /inasistencias\s+condonadas\s*:/i.test(
observacion
);
};

// ============================================================
// CONDONACIONES VIEJAS
// ============================================================

const devuelveCantidadCondonacionesViejas = (info) => {
try {
const condonaciones = info?.condonas || [];

return condonaciones.reduce((total, condona) => {

// Solo nos interesan las condonaciones de inasistencias
if (
String(condona.tipo || "").toLowerCase() !==
"inasistencias"
) {
return total;
}

// NUEVO SISTEMA:
// no restamos porque las faltas ya están inactivas
if (esCondonacionNueva(condona)) {
return total;
}

// VIEJO SISTEMA:
// sigue funcionando como crédito
const cantidad = Number(condona.cantidad);

return total +
(Number.isFinite(cantidad) ? cantidad : 0);

}, 0);

} catch (error) {
console.error(
"Error calculando condonaciones viejas:",
error
);

return 0;
}
};

// ============================================================
// CANTIDAD INASISTENCIAS
// ============================================================

const devuelveCantidadInasistencias = (info) => {
try {
const ausencias = info?.Ausencia || [];
const pases = info?.PaseDeSalidas || [];

// ------------------------------------------------------------
// 1. SOLAMENTE AUSENCIAS ACTIVAS
// ------------------------------------------------------------

const ausenciasActivas =
ausencias.filter(esInasistenciaActiva);

// ------------------------------------------------------------
// 2. PASES VALIDOS
// ------------------------------------------------------------

const pasesValidos = pases
.filter((pase) =>
[
"Permiso Especial",
"Servicio Externo",
"Franco de Honor"
].includes(pase.tipo) &&
pase.fechaHoraSalida &&
pase.fechaHoraRegreso
)
.map((pase) => ({
salida: new Date(pase.fechaHoraSalida),
regreso: new Date(pase.fechaHoraRegreso)
}));

// ------------------------------------------------------------
// 3. AUSENCIAS NO CUBIERTAS POR PASE
// ------------------------------------------------------------

let inasistenciasAntesDeCondonar = 0;

ausenciasActivas.forEach((ausencia) => {
const fechaAusencia =
new Date(ausencia.fecha);

const cubiertaPorPase =
pasesValidos.some((pase) =>
fechaAusencia >= pase.salida &&
fechaAusencia <= pase.regreso
);

if (!cubiertaPorPase) {
inasistenciasAntesDeCondonar++;
}
});

// ------------------------------------------------------------
// 4. CONDONACIONES DEL SISTEMA VIEJO
// ------------------------------------------------------------

const cantidadCondonacionesViejas =
devuelveCantidadCondonacionesViejas(info);

// ------------------------------------------------------------
// 5. RESULTADO COMPUTABLE
// ------------------------------------------------------------

const inasistenciasComputables = Math.max(
0,
inasistenciasAntesDeCondonar -
cantidadCondonacionesViejas
);

return {
totalInasistencias:
ausenciasActivas.length,

inasistenciasAntesDeCondonar,

cantidadCondonacionesViejas,

inasistenciasComputables
};

} catch (error) {
console.error(
"Error calculando inasistencias:",
error
);

return {
totalInasistencias: 0,
inasistenciasAntesDeCondonar: 0,
cantidadCondonacionesViejas: 0,
inasistenciasComputables: 0
};
}
};

// ============================================================
// FECHAS
// ============================================================

const invertirFecha = (fecha) => {
if (!fecha) return "-";

const fechaLimpia =
String(fecha).split("T")[0];

const partes =
fechaLimpia.split("-");

return partes.length === 3
? `${partes[2]}-${partes[1]}-${partes[0]}`
: fecha;
};

const fechaLocal = (fecha) => {
if (!fecha) return "-";

try {
return new Date(fecha)
.toLocaleDateString("es-AR");
} catch {
return fecha;
}
};

const claveFechaAsistencia = (fecha) => {
if (!fecha) return "";

try {
return new Date(fecha)
.toLocaleDateString("en-CA", {
timeZone:
"America/Argentina/Buenos_Aires"
});
} catch {
return String(fecha).split("T")[0];
}
};

const horaLocalAsistencia = (fecha) => {
if (!fecha) return "-";

try {
return new Date(fecha)
.toLocaleTimeString("es-AR", {
timeZone:
"America/Argentina/Buenos_Aires",
hour: "2-digit",
minute: "2-digit",
second: "2-digit",
hour12: false
});
} catch {
return "-";
}
};

// ============================================================
// INFO SANCION / AVISO / PASE
// ============================================================

const seteaSancion = (sancion) => {
setSancionModalInfo(sancion);
setModalInfoSancion(true);
};

const seteaPaseSalida = (pase) => {
setPaseDeSalida(pase);
setModalPaseSalida(true);
};

const seteaAviso = (aviso) => {
setAvisoModalInfo(aviso);
setModalInfoAviso(true);
};

// ============================================================
// JUSTIFICAR INASISTENCIA
// ============================================================

const seteaInasistencia = (inasistencia) => {
const puedeJustificar =
comprueboPermisos(
Usuario.funcion,
"Justifica Inasistencia"
) ||
Usuario.destino == 7;

if (!puedeJustificar) return;

setInasistenciaSeleccionada(inasistencia);
setVeoModalJustifica(true);
};

const manejoCierroJustifico = () => {
setVeoModalJustifica(false);
setInasistenciaSeleccionada(null);
};

// ============================================================
// DATOS DERIVADOS
// ============================================================

const sancionesActivas =
cadete?.Sanciones?.filter(
(s) => s.estado !== "Vencida"
) || [];

const inasistenciasActivas =
cadete?.Ausencia?.filter(
esInasistenciaActiva
) || [];

const asistenciasPorFecha =
(cadete?.Asistencias || []).reduce(
(acumulador, asistencia) => {

const clave =
claveFechaAsistencia(
asistencia.fecha
);

if (!clave) return acumulador;

acumulador[clave] =
(acumulador[clave] || 0) + 1;

return acumulador;

}, {});

const cantidadAmonestaciones =
devuelveCantidadAmonestaciones({
...(cadete || {}),
Sanciones: sancionesActivas
});

const resumenInasistencias =
devuelveCantidadInasistencias(
cadete || {}
);

// ============================================================
// PERMISOS
// ============================================================

const puedeEditar =
Usuario.destino == 2 ||
Usuario.destino == 7 ||
comprueboPermisos(
Usuario.funcion,
"Edita datos cadete"
);

const puedeCondonar =
Usuario.destino == 7 ||
comprueboPermisos(
Usuario.funcion,
"Condono Inasistencias"
);

const puedeVerCambiosCondicion =
comprueboPermisos(
Usuario.funcion,
"Veo Cambios Condicion"
);

const puedeVerLegajoVirtual =
comprueboPermisos(
Usuario.funcion,
"Veo Legajo Virtual"
);

// ============================================================
// CARGANDO
// ============================================================

if (!visible) {
return (
<div className="cadedit-safe-main">
<div className="cadedit-safe-loading">

<strong>
Cargando legajo...
</strong>

<span>
Obteniendo información actualizada del cadete.
</span>

</div>
</div>
);
}

// ============================================================
// ERROR
// ============================================================

if (errorConsulta || !cadete) {
return (
<div className="cadedit-safe-main">

<div className="cadedit-safe-loading">

<strong>
La consulta no devolvió un cadete
</strong>

<span>
Verifique el DNI utilizado.
</span>

<button
type="button"
className="cadedit-safe-btn cadedit-safe-btn-secondary"
onClick={() => window.close()}
>
Cerrar
</button>

</div>
</div>
);
}

return (
<>

<div className="cadedit-safe-main">

{/* ====================================================== */}
{/* PERFIL */}
{/* ====================================================== */}

<section className="cadedit-safe-profile">

<div className="cadedit-safe-profile-main">

<div className="cadedit-safe-photo-wrap">

{cadete.fotoCadete ? (

<img
src={`https://wwwa.isepsantafe.net.ar/imagenes/${cadete.fotoCadete}`}
alt="Foto Cadete"
className="cadedit-safe-photo"
onClick={() =>
muestroFoto(cadete.fotoCadete)
}
/>

) : (

<div className="cadedit-safe-photo cadedit-safe-photo-empty">

{cadete.cadeteApellido
?.charAt(0)
?.toUpperCase() || "C"}

</div>

)}

{cadete.fotoCadete &&
<span>Ver foto</span>}

</div>

<div className="cadedit-safe-identity">

<div className="cadedit-safe-eyebrow">
LEGAJO DEL CADETE
</div>

<h1>
{cadete.cadeteApellido}{" "}
{cadete.cadeteNombre}
</h1>

<div className="cadedit-safe-badges">

<span className="cadedit-safe-badge cadedit-safe-badge-primary">
DNI {cadete.cadeteDni}
</span>

<span className="cadedit-safe-badge">
{cadete.cadeteSede || "Sin sede"}
</span>

<span className="cadedit-safe-badge">
Promoción{" "}
{cadete.Promocions?.[0]?.nombre || "-"}
</span>

{cadete.cadeteCondicion && (
<span className="cadedit-safe-badge">
{cadete.cadeteCondicion}
</span>
)}

</div>
</div>
</div>

<div className="cadedit-safe-data-grid">

<DatoPerfil
label="Organización"
value={
cadete.Seccion
? `${cadete.Seccion.nombre || ""} · ${cadete.Seccion.Compania?.nombre || ""}`
: "Sin sección asignada"
}
/>

<DatoPerfil
label="Departamento"
value={cadete.cadeteUR || "-"}
/>

<DatoPerfil
label="Ciudad"
value={cadete.cadeteCiudad || "-"}
/>

<DatoPerfil
label="Edad"
value={
cadete.fechaNacimiento
? `${devolvemeLaEdad(cadete.fechaNacimiento)} años`
: "-"
}
/>

<DatoPerfil
label="Email"
value={cadete.cadeteEmail || "-"}
/>

</div>
</section>

{/* ====================================================== */}
{/* RESUMEN */}
{/* ====================================================== */}

<section className="cadedit-safe-summary">

<ResumenCard
clase="cadedit-safe-summary-danger"
label="Pliegos"
valor={sancionesActivas.length}
detalle={`${cantidadAmonestaciones} confirmadas`}
/>

<ResumenCard
clase="cadedit-safe-summary-warning"
label="Inasistencias"
valor={
resumenInasistencias
.inasistenciasComputables
}
detalle={
`${inasistenciasActivas.length} activas registradas`
}
/>

<ResumenCard
clase="cadedit-safe-summary-medical"
label="Reconocimientos"
valor={
cadete.CarpetaMedicas?.length || 0
}
detalle="médicos registrados"
/>

<ResumenCard
clase="cadedit-safe-summary-success"
label="Presentes"
valor={
cadete.Asistencias?.length || 0
}
detalle="asistencias registradas"
/>

</section>

{/* ====================================================== */}
{/* ACCIONES */}
{/* ====================================================== */}

<section className="cadedit-safe-actions">

<div className="cadedit-safe-actions-title">
<span>ACCIONES DEL LEGAJO</span>
<strong>Gestión del cadete</strong>
</div>

<div className="cadedit-safe-actions-buttons">

<button
type="button"
className="cadedit-safe-btn cadedit-safe-btn-warning"
onClick={() =>
setVerSancionar(true)
}
>
⚖ Sancionar
</button>

{puedeEditar && (

<button
type="button"
className="cadedit-safe-btn cadedit-safe-btn-primary"
onClick={() =>
setModaAbierto(true)
}
>
✎ Editar datos
</button>

)}

{puedeCondonar && (

<button
type="button"
className="cadedit-safe-btn cadedit-safe-btn-danger"
onClick={() =>
setVeoModalCondono(true)
}
>
✓ Condonar inasistencias
</button>

)}

{puedeVerLegajoVirtual && (

<button
type="button"
className={`cadedit-safe-btn cadedit-safe-btn-legajo ${
veoLegajoVirtual
? "cadedit-safe-btn-legajo-active"
: ""
}`}
onClick={() =>
setVeoLegajoVirtual(
(prev) => !prev
)
}
>
📁{" "}
{veoLegajoVirtual
? "Ocultar Legajo Virtual"
: "Legajo Virtual"}
</button>

)}

<button
type="button"
className="cadedit-safe-btn cadedit-safe-btn-secondary"
onClick={() => window.close()}
>
× Cerrar
</button>

</div>
</section>

{/* ====================================================== */}
{/* LEGAJO VIRTUAL */}
{/* ====================================================== */}

{puedeVerLegajoVirtual &&
veoLegajoVirtual && (

<section className="cadedit-safe-legajo">

<div className="cadedit-safe-legajo-header">

<div>
<span>
DOCUMENTACIÓN DIGITAL
</span>

<h2>
Legajo Virtual
</h2>

<p>
Documentación y archivos incorporados al legajo del cadete.
</p>
</div>

<button
type="button"
className="cadedit-safe-legajo-close"
onClick={() =>
setVeoLegajoVirtual(false)
}
>
×
</button>

</div>

<div className="cadedit-safe-legajo-content">

<LegajoVirtual
cadete={cadete}
/>

</div>

</section>

)}

{/* ====================================================== */}
{/* HISTORIAL */}
{/* ====================================================== */}

<div className="cadedit-safe-history-title">

<div>
<span>
HISTORIAL DEL LEGAJO
</span>

<h2>
Registros del cadete
</h2>
</div>

<small>
Seleccione un registro para consultar su detalle
</small>

</div>

<div className="cadedit-safe-cards-grid">

{/* ================================================== */}
{/* SANCIONES */}
{/* ================================================== */}

<HistorialCard
titulo="Pliegos de Sanción"
cantidad={sancionesActivas.length}
resumen={`${cantidadAmonestaciones} confirmadas`}
vacio="No registra sanciones activas"
>

{sancionesActivas.map(
(sancion, index) => {

const cantidad =
sancion.estado ===
"Finalizada Reclamada"
? sancion.cantidadResuelveRecurso
: sancion.cantidadConfirma;

return (

<FilaHistorial
key={sancion.id || index}
onClick={() =>
seteaSancion({
...sancion,
cadete
})
}
>

<strong>
{index + 1}.{" "}
{invertirFecha(
sancion.fechaFaltaCometida
)}
</strong>

<span>
{sancion.tipo || "Sin tipo"}{" "}
· Cantidad:{" "}
{cantidad || "-"} ·{" "}
{sancion.estado || "-"}
</span>

</FilaHistorial>

);

}
)}

</HistorialCard>

{/* ================================================== */}
{/* INASISTENCIAS */}
{/* ================================================== */}

<HistorialCard
titulo="Inasistencias Activas"
cantidad={inasistenciasActivas.length}
resumen={
`${resumenInasistencias.inasistenciasComputables} computables`
}
vacio="No registra inasistencias activas"
>

{inasistenciasActivas.map(
(ausencia, index) => (

<FilaHistorial
key={ausencia.id || index}
onClick={() =>
seteaInasistencia(ausencia)
}
>

<strong>
{index + 1}.{" "}
{invertirFecha(
ausencia.fecha
)}
</strong>

<span>

{ausencia.tipo || "Sin tipo"}{" "}
· Justificada:{" "}

{ausencia.justificada === "No"
? "No"
: `${ausencia.justificada || "-"}${
ausencia.observacion
? ` (${ausencia.observacion})`
: ""
}`}

</span>

</FilaHistorial>

))}

</HistorialCard>

{/* ================================================== */}
{/* CONDONACIONES */}
{/* ================================================== */}

<HistorialCard
titulo="Condonaciones"
cantidad={
cadete.condonas?.length || 0
}
vacio="No registra condonaciones"
>

{cadete.condonas?.map(
(condona, index) => (

<FilaHistorial
key={condona.id || index}
>

<strong>
{index + 1}.{" "}
{fechaLocal(
condona.createdAt
)}
</strong>

<span>

{condona.tipo || "Sin tipo"}

{condona.observacion
? ` · ${condona.observacion}`
: ""}

</span>

</FilaHistorial>

))}

</HistorialCard>

{/* ================================================== */}
{/* GUARDIAS */}
{/* ================================================== */}

<HistorialCard
titulo="Guardias"
cantidad={
cadete.Guardias?.length || 0
}
vacio="No registra guardias"
>

{cadete.Guardias?.map(
(guardia, index) => (

<FilaHistorial
key={guardia.id || index}
>

<strong>
{index + 1}.{" "}
{invertirFecha(
guardia.fechaGuardia
)}
</strong>

<span>
{guardia.tipo || "Sin tipo"}
</span>

</FilaHistorial>

))}

</HistorialCard>

{/* ================================================== */}
{/* RECONOCIMIENTOS */}
{/* ================================================== */}

<HistorialCard
titulo="Reconocimientos Médicos"
cantidad={
cadete.CarpetaMedicas?.length || 0
}
vacio="No registra reconocimientos médicos"
onClick={
cadete.CarpetaMedicas?.length
? () =>
manejoModalInfo(
cadete.CarpetaMedicas
)
: undefined
}
>

{cadete.CarpetaMedicas?.length > 0 && (

<div className="cadedit-safe-card-message">
Tocar para consultar los reconocimientos médicos.
</div>

)}

</HistorialCard>

{/* ================================================== */}
{/* AVISOS */}
{/* ================================================== */}

<HistorialCard
titulo="Avisos"
cantidad={
cadete.excepciones?.length || 0
}
vacio="No registra avisos"
>

{cadete.excepciones?.map(
(aviso, index) => (

<FilaHistorial
key={aviso.id || index}
onClick={() =>
seteaAviso(aviso)
}
>

<strong>
{index + 1}.{" "}
{fechaLocal(aviso.fecha)}
</strong>

<span>
{aviso.tipo || "Sin tipo"}
</span>

</FilaHistorial>

))}

</HistorialCard>

{/* ================================================== */}
{/* PRESENTES */}
{/* ================================================== */}

<HistorialCard
titulo="Presentes Registrados"
cantidad={
cadete.Asistencias?.length || 0
}
vacio="No registra presentes"
>

{cadete.Asistencias?.map(
(asistencia, index) => {

const claveFecha =
claveFechaAsistencia(
asistencia.fecha
);

const cantidadMismoDia =
asistenciasPorFecha[
claveFecha
] || 1;

const tieneMultiplesMarcas =
cantidadMismoDia > 1;

return (

<FilaHistorial
key={asistencia.id || index}
resaltado={
tieneMultiplesMarcas
}
>

<strong>

{index + 1}.{" "}
{fechaLocal(
asistencia.fecha
)}

{tieneMultiplesMarcas && (

<span
style={{
display: "inline-block",
marginLeft: "8px",
padding: "2px 7px",
borderRadius: "999px",
background: "#f59e0b",
color: "#111827",
fontSize: "11px",
fontWeight: "800"
}}
>

{cantidadMismoDia}{" "}
marcas en el dia

</span>

)}

</strong>

<span>

{asistencia.tipo ||
"Sin tipo"}{" "}
· Hora:{" "}

<strong>
{horaLocalAsistencia(
asistencia.fecha
)}
</strong>

{asistencia.estado
? ` · ${asistencia.estado}`
: ""}

</span>

</FilaHistorial>

);

}
)}

</HistorialCard>

{/* ================================================== */}
{/* CAMBIOS DE CONDICION */}
{/* ================================================== */}

{puedeVerCambiosCondicion && (

<HistorialCard
titulo="Cambios de Condición"
cantidad={
cadete.CambioCondicions
?.length || 0
}
vacio="No registra cambios de condición"
>

{cadete.CambioCondicions?.map(
(cambio, index) => (

<FilaHistorial
key={cambio.id || index}
>

<strong>
{index + 1}.{" "}
{fechaLocal(
cambio.createdAt
)}
</strong>

<span>

{cambio.condicionAnterior ||
"-"}{" "}
→{" "}
{cambio.condicionActual ||
"-"}

{cambio.descripcion
? ` · ${cambio.descripcion}`
: ""}

{cambio.resolucion
? ` · Res: ${cambio.resolucion}`
: ""}

</span>

</FilaHistorial>

))}

</HistorialCard>

)}

{/* ================================================== */}
{/* PASES SALIDA */}
{/* ================================================== */}

<HistorialCard
titulo="Pases de Salida"
cantidad={
cadete.PaseDeSalidas?.length ||
0
}
vacio="No registra pases de salida"
>

{cadete.PaseDeSalidas?.map(
(pase, index) => (

<FilaHistorial
key={pase.id || index}
onClick={() =>
seteaPaseSalida(pase)
}
>

<strong>
{index + 1}.{" "}
{fechaLocal(pase.createdAt)}
</strong>

<span>

{pase.tipo || "Sin tipo"}

{pase.estado
? ` · ${pase.estado}`
: ""}

</span>

</FilaHistorial>

))}

</HistorialCard>

</div>

<FooterCorp />

</div>

{/* ====================================================== */}
{/* EDITAR CADETE */}
{/* ====================================================== */}

<ModalCadete
isOpen={modalAbierto}
onClose={() =>
setModaAbierto(false)
}
>

<CadeteFormEdit
cadete={cadete}
onClose={(dato) =>
manejoCierre(dato)
}
/>

</ModalCadete>

{/* ====================================================== */}
{/* INFO SANCION */}
{/* ====================================================== */}

<ModalInfoSancion
isOpen={modalInfoSancion}
onClose={() => {
setModalInfoSancion(false);
setSancionModalInfo(null);
}}
>

<div
style={{
height: "500px",
overflow: "auto"
}}
>

{sancionModalInfo && (

<Sancion
sancionPasada={
sancionModalInfo
}
onClose={() =>
setModalInfoSancion(false)
}
/>

)}

</div>

</ModalInfoSancion>

{/* ====================================================== */}
{/* INFO AVISO */}
{/* ====================================================== */}

<ModalInfoAviso
isOpen={modalInfoAviso}
onClose={() => {
setModalInfoAviso(false);
setAvisoModalInfo(null);
}}
>

<div
style={{
height: "500px",
overflow: "auto"
}}
>

{avisoModalInfo && (
<InfoAviso
aviso={avisoModalInfo}
/>
)}

</div>

</ModalInfoAviso>

{/* ====================================================== */}
{/* CONDONAR */}
{/* ====================================================== */}

<ModalCondono
isOpen={veoModalCondono}
onClose={() =>
setVeoModalCondono(false)
}
>

<div
style={{
maxHeight: "650px",
overflow: "auto"
}}
>

<Condona
cadeteDni={cadete.cadeteDni}
ausencias={inasistenciasActivas}
actualiza={obtieneCadete}
cierra={() =>
setVeoModalCondono(false)
}
/>

</div>

</ModalCondono>

{/* ====================================================== */}
{/* PASE SALIDA */}
{/* ====================================================== */}

<ModalInfoPaseSalida
isOpen={modalPaseSalida}
onClose={() => {
setModalPaseSalida(false);
setPaseDeSalida(null);
}}
>

<div
style={{
height: "500px",
overflow: "auto"
}}
>

{paseDeSalida && (

<PaseDeSalidaInfo
paseDeSalida={paseDeSalida}
/>

)}

</div>

</ModalInfoPaseSalida>

{/* ====================================================== */}
{/* CARPETA MEDICA */}
{/* ====================================================== */}

{modalVeoInfo && (

<ModalVeoInfo
isOpen={modalVeoInfo}
onClose={() =>
setModalVeoInfo(false)
}
>

<div
style={{
padding: "20px",
border: "1px grey solid",
maxHeight: "600px",
overflow: "auto"
}}
>

<h3>
Carpetas Médicas{" "}
{cadete.cadeteApellido}
</h3>

<CadeteInfoCard
carpetas={
cadete.CarpetaMedicas
}
/>

</div>

</ModalVeoInfo>

)}

{/* ====================================================== */}
{/* CREAR SANCION */}
{/* ====================================================== */}

<ModalCreaSancion
isOpen={verSancionar}
onClose={() =>
setVerSancionar(false)
}
>

<div
style={{
overflow: "auto",
height: "500px"
}}
>

<div
style={{
padding: "10px",
width: "100%",
display: "flex",
flexDirection: "column",
alignItems: "center",
textAlign: "center"
}}
>

<h5>
Módulo de creación de sanciones
</h5>

{cadete && (

<CreaSancion
cadete={datosCadeteSancion}
onClose={() => {
obtieneCadete();
setVerSancionar(false);
}}
/>

)}

</div>
</div>

</ModalCreaSancion>

{/* ====================================================== */}
{/* JUSTIFICAR INASISTENCIA */}
{/* ====================================================== */}

<ModalEditaJustifica
isOpen={veoModalJustifica}
onClose={manejoCierroJustifico}
>

<h5>
Módulo de justificación de inasistencias
</h5>

{inasistenciaSeleccionada && (

<JustificarInasistencia
inasistencia={
inasistenciaSeleccionada
}
cadete={cadete}
actualiza={() => {
obtieneCadete();
manejoCierroJustifico();
}}
/>

)}

</ModalEditaJustifica>

</>
);
};

// ============================================================
// DATOS PERFIL
// ============================================================

const DatoPerfil = ({
label,
value
}) => (

<div className="cadedit-safe-data-item">
<span>{label}</span>
<strong>{value}</strong>
</div>

);

// ============================================================
// RESUMEN
// ============================================================

const ResumenCard = ({
clase,
label,
valor,
detalle
}) => (

<div
className={
`cadedit-safe-summary-card ${clase || ""}`
}
>

<span>{label}</span>
<strong>{valor}</strong>
<small>{detalle}</small>

</div>

);

// ============================================================
// CARD HISTORIAL
// ============================================================

const HistorialCard = ({
titulo,
cantidad,
resumen,
vacio,
children,
onClick
}) => (

<section
className={`Cards cadedit-safe-history-card ${
onClick
? "cadedit-safe-card-clickable"
: ""
}`}
onClick={onClick}
>

<div className="cadedit-safe-card-header">

<div>
<span>{titulo}</span>
{resumen &&
<small>{resumen}</small>}
</div>

<strong>
{cantidad || 0}
</strong>

</div>

{Number(cantidad) > 0 ? (

<div
className="cadedit-safe-card-list"
onClick={(event) => {
if (!onClick) return;

event.stopPropagation();
onClick();
}}
>

{children}

</div>

) : (

<div className="cadedit-safe-card-empty">
{vacio}
</div>

)}

</section>

);

// ============================================================
// FILA HISTORIAL
// ============================================================

const FilaHistorial = ({
children,
onClick,
resaltado = false
}) => (

<button
type="button"
className={`cadedit-safe-history-row ${
onClick
? "cadedit-safe-history-row-clickable"
: ""
}`}
onClick={onClick}
disabled={!onClick}
style={
resaltado
? {
border: "2px solid #f59e0b",
background: "#fff7ed",
boxShadow:
"0 0 0 2px rgba(245, 158, 11, 0.12)"
}
: undefined
}
>

{children}

</button>

);

export default CadetesEdit;